export function treatUrl(url: string) {
  let normalizedUrl = url.trim().replace(/(^\w+:|^)\/\//, '');

  if (normalizedUrl.lastIndexOf('/') === normalizedUrl.length - 1) {
    normalizedUrl = normalizedUrl.slice(0, normalizedUrl.length - 1);
  }

  return normalizedUrl;
}
